export default function MainNav() {
  let navEl

  const init = () => {
    navEl = $('.js-main-nav')
    if (navEl) {
      initMobileMenuToggle()
      initSubMenuToggle()
    }
  }

  // Open/close navigation on mobile (top-level menu always visible on desktop)
  const initMobileMenuToggle = () => {
    const toggleBtn = navEl.find('.js-mob-menu-toggle')

    toggleBtn.on('click', () => {
      const isOpen = navEl.hasClass('c-header--open')
      const menuContainer = navEl.find('.c-header__menu-container')
      const menuInner = navEl.find('.c-header__menu-content')

      navEl.toggleClass('c-header--open')
      toggleBtn.find('.c-header__mob-menu-icon--open').toggleClass('hidden')
      toggleBtn.find('.c-header__mob-menu-icon--close').toggleClass('hidden')

      if (isOpen) {
        collapseSection(menuContainer, menuInner)
      } else {
        expandSection(menuContainer, menuInner)
      }
    })
  }

  const closeSubMenus = (method) => {
    const expandedLis = $('.c-main-nav__item--sub-menu-open')
    expandedLis.each(function () {
      const expandedLi = $(this)
      const expandedContainer = expandedLi.find('.c-main-nav__sub-menu-container')
      const expandedInner = expandedLi.find('.c-main-nav__sub-menu-content')
      expandedInner.css('opacity', 1)

      if (method === 'fade') {
        fadeoutContent(expandedContainer, expandedInner)
      } else {
        collapseSection(expandedContainer, expandedInner)
      }

      expandedLi.removeClass('c-main-nav__item--sub-menu-open')
      expandedLi.find('.js-toggle-sub-menu').attr('aria-expanded', false)
    })
  }

  // Open/close sub-menus (same behaviour for both mob/desktop - CSS controls differences in appearance)
  const initSubMenuToggle = () => {
    let subMenuToggle = navEl.find('.js-toggle-sub-menu')

    subMenuToggle.on('click', function (e) {
      e.preventDefault()
      const t = $(this)
      const parentLi = t.parent()
      const isAlreadyOpen = parentLi.hasClass('c-main-nav__item--sub-menu-open')

      const expandedLis = $.find('.c-main-nav__item--sub-menu-open')
      const isAnotherSubMenuOpen = expandedLis.length > 0 && !expandedLis.includes(parentLi) && !isAlreadyOpen
      const isTabletLandscapeUp = window.innerWidth >= 900

      if (isAnotherSubMenuOpen && isTabletLandscapeUp) {
        closeSubMenus('fade')
      } else {
        // Close any sub-menus currently open (including clicked one if user is toggling it off)
        closeSubMenus('collapse')
      }

      // If sub-menu user clicked is not already open, open it
      if (!isAlreadyOpen) {
        parentLi.addClass('c-main-nav__item--sub-menu-open')
        t.attr('aria-expanded', 'true')

        const subMenuContainer = parentLi.find('.c-main-nav__sub-menu-container')
        const subMenuContent = parentLi.find('.c-main-nav__sub-menu-content')

        if (isAnotherSubMenuOpen && isTabletLandscapeUp) {
          fadeinContent(subMenuContainer, subMenuContent)
        } else {
          expandSection(subMenuContainer, subMenuContent)
        }
      }

      $(document)
        .on('keyup', (e) => {
          // Closes submenu on Escape key press, and returns focus to menu item that opened it.
          if (e.key === 'Escape') {
            closeSubMenus()
            parentLi.find('.js-toggle-sub-menu').trigger('focus')
          }
        })
        .on('click', (e) => {
          // Closes submenu on click outside of header
          if (!navEl.is(e.target) && navEl.has(e.target).length === 0) {
            closeSubMenus()
          }
        })
    })
  }

  const expandSection = (container, inner) => {
    // Get  height of the element's inner content
    var sectionHeight = inner.outerHeight()
    container.css('visibility', 'visible')
    inner.css('opacity', 1)

    // Have the container transition to the height of its inner content
    container.css('height', sectionHeight + 'px')

    const removeFixedHeightStyle = function (e) {
      // Remove this listener so it only gets triggered once
      container.off('transitionend', removeFixedHeightStyle)

      // Set height to auto once expanded to handle screen resizing etc.
      container.css('height', 'auto')
    }

    // When the next CSS transition finishes (which should be the one we just triggered)
    container.on('transitionend', removeFixedHeightStyle)
  }

  function collapseSection(container, inner) {
    // Get  height of the element's inner content
    var sectionHeight = inner.outerHeight()

    // Temporarily disable all CSS transitions
    var elementTransition = container.css('transition')
    container.css('transition', '')

    /*
     * On the next frame (as soon as the previous style change has taken effect),
     * explicitly set the container's height to its current pixel height, so we
     * aren't transitioning out of 'auto'
     */
    requestAnimationFrame(function () {
      // eslint-disable-line
      container.css('height', sectionHeight + 'px')
      container.css('transition', elementTransition)

      /*
       * On the next frame (as soon as the previous style change has taken effect),
       * have the container transition to height: 0
       */
      requestAnimationFrame(function () {
        // eslint-disable-line
        container.css('height', 0)
        setTimeout(() => {
          container.css('visibility', 'hidden')
        }, 100)
      })
    })
  }

  const fadeinContent = (container, inner) => {
    container.css('height', 'auto')
    container.css('visibility', 'visible')
    inner.css('opacity', 1)
    inner.css('transition', 'opacity 300ms')
  }

  const fadeoutContent = (container, inner) => {
    inner.css('opacity', 0)
    inner.css('transition', 'opacity 300ms')
    container.css('height', 0)
    container.css('visibility', 'hidden')
  }

  return {
    init: init,
  }
}
